import Vue from 'vue';
import { api } from "../../services/Api.js";

export function add_calendar_item({ state }, payload){

    // add token to payload
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    //console.log("add_calendar_item",payload)
    

    return api.post(school,"add_calendar_item.php",payload)
    .then(result=>{
      Vue.$toaster.toast("language.add_calendar_item_success");
      return result
    })
    .catch(
    error=>{
      Vue.$toaster.toast("language.add_calendar_item_error: "+error);
      return error;
    })

   
    
  }